import {Component} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';
import {EmploymentStatus} from '../../../@models/employment-status.model';

@Component({
  selector: 'bb-current-status',
  templateUrl: './current-status.component.html',
  styleUrls: ['./current-status.component.scss'],
})
export class CurrentStatusComponent {
  employment_type = this.loan.form.get('employment_info.employment_type');
  current_status = this.loan.form.get('current_status');
  employment_status = this.current_status.get('employment_status');
  looking = EmploymentStatus.KnownStatuses.looking;
  pre_employment = EmploymentStatus.KnownStatuses.pre_employment;
  done_requirements = EmploymentStatus.KnownStatuses.done_requirements;
  balik_manggagawa = EmploymentStatus.KnownStatuses.balik_manggagawa;
  working = EmploymentStatus.KnownStatuses.working;
  sea_onboard = EmploymentStatus.KnownStatuses.sea_onboard;

  requiredFields = {
    balik_manggagawa: [
      'average_monthly_remittance', 
      'datetime_to_work',
      'datetime_contract_end',
      'unlimited_contract'
    ],
    working_flyback: [
      'average_monthly_remittance', 
      'datetime_to_philippines',
      'datetime_contract_end',
      'unlimited_contract'
    ],
    working: [
      'average_monthly_remittance', 
      'datetime_contract_end',
      'unlimited_contract'
    ],
    pre_employment: [],
    done_requirements: ['tentative_departure_date'],
    sea_signed: ['tentative_departure_date'],
    sea_vacation: [],
    sea_onboard: ['datetime_contract_end'],
  };

  isUpdating = false;

  constructor(public loan: LoanApplicationService) {
    this.current_status.get('employment_status').valueChanges.subscribe(value => {
      if (this.isUpdating) {
        return;
      }
      this.isUpdating = true;
      const nonRequiredFields: string[] = Object.keys(this.current_status.value).filter((field) => {
        return !this.requiredFields[value].includes(field) && field !== 'employment_status';
      });
      nonRequiredFields.forEach((field) => {
        const control = this.current_status.get(field);
        control.clearValidators();
        control.updateValueAndValidity();
      });
      this.isUpdating = false;
    });
  }
}
